import { render, staticRenderFns } from "./OurProjectsDialog.vue?vue&type=template&id=15c2598a&"
import script from "./OurProjectsDialog.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OurProjectsDialog.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15c2598a')) {
      api.createRecord('15c2598a', component.options)
    } else {
      api.reload('15c2598a', component.options)
    }
    module.hot.accept("./OurProjectsDialog.vue?vue&type=template&id=15c2598a&", function () {
      api.rerender('15c2598a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/core-layout/components/CoreHeader/components/mobile/SideMenu/components/OurProjectsDialog.vue"
export default component.exports